module.exports = __webpack_public_path__ + "img/public/AdminIcons/dashboardIcon.svg?02b03c18";